export interface ClassTypeDto {
  ClassTypeID: number;
  TypeName: string;
  bActive: boolean;
  TradeClassesCount: number;
}
